export default __webpack_public_path__ + "static/media/ek-coffee.dea6c507.jpg";